export const getContentPadding = (
  noPadding: boolean,
  isMobile: boolean,
  isTablet: boolean
): number => {
  if (noPadding) return 0;
  if (isMobile) return 2;
  if (isTablet) return 2.5;
  return 3;
};

export const getMinHeight = (isMobile: boolean): number => {
  return isMobile ? 48 : 56;
};
